export default class CartProductCounter {

    refresh() {
        console.log('amounted to cart!');
    }
}